export const UNVERIFIED = 'unverified';
export const UNDER_REVIEW = 'in_progress';
export const VERIFIED = 'verified';